export default __webpack_public_path__ + "assets/pin-component.1600e31c.svg";